module.exports = __webpack_public_path__ + "img/甘肃经济广播_02.ede4765f.jpg";